<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vng1Cy/Images/JonesCovers2.jpg?1734954337507" alt="This image is the cover for the book Every Move You Make"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Every Move You Make
      </h1>
      <p class="bookDescription body article font2">
        <p>“…dark, disturbing, and completely gripping.” –RT BOOK REVIEWS<br/><br/> Following her divorce, Regan McKinney moves to San Francisco to start a new life, but she couldn’t have chosen a worse time to arrive. The city is gripped with fear as a brutal killer stalks the streets, murdering women—women who look a lot like Regan.<br/><br/> Though disturbed by the vicious crimes, Regan is determined to get on with her life, landing a promising job and finding her confidence again when she catches the attention of her handsome dance instructor.<br/><br/> But she’ll soon learn that Peter Smith isn’t the only one who has his eye on her. Will she be safe enough in the arms of the man gunning for her affection, with a sadistic killer gunning for her life?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jill Jones
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fb0ba2b